import { ListItemIcon, ListItemText, MenuItem, type MenuItemProps } from '@mui/material'
import { Favorite } from '@tunasong/icons'
import { type FC } from 'react'
import type { FavoriteControlProps } from './favorite-props.js'
import { useFavorites } from './favorites.hook.js'

type FavoriteMenuItemProps = FavoriteControlProps<MenuItemProps>

export const FavoriteMenuItem: FC<FavoriteMenuItemProps> = props => {
  const { onClick, ...restProps } = props
  const { currentFavorite, toggleFavorite, getFavoriteTemplateFromEntity } = useFavorites()
  const template = 'template' in restProps ? restProps.template : getFavoriteTemplateFromEntity(restProps.entity)

  return (
    <MenuItem
      onClick={ev => {
        ev.preventDefault()
        ev.stopPropagation()
        toggleFavorite(template)
        if (onClick) {
          onClick(ev)
        }
      }}
      {...restProps}
    >
      <ListItemIcon>
        <Favorite color={currentFavorite ? 'error' : 'inherit'} />
      </ListItemIcon>
      <ListItemText primary={currentFavorite ? 'Remove from Favorites' : 'Add to Favorites'} />
    </MenuItem>
  )
}

export default FavoriteMenuItem
